import Site from './Site';

export default class SiteUK extends Site {
  constructor () {
    super();
    this.currencyCode = 'GBP';
    this.shortWeight = 'kg';
    this.siteCode = 'UK';
    this.maxGoalValue = 80;
    this.minimumBetValue = 150;
    this.convertionRate = 0.77;
    this.siteName = 'the U.K';
    this.moneyText = 'Pound Sterling'
  }

  useSI() {
    return true;
  }

  convertedGoal() {
    return this.convertWeightToKg(34);
  }
}
